import { GetterTree } from 'vuex';
import IRequestState from './types/IRequestState';
import IRootState from '@/store/types/IRootState';

const getters: GetterTree<IRequestState, IRootState> = {
  meta: (state) => state.meta,
  header: (state) => state.header,
  form: (state) => state.form,
};

export default getters;
